import type { CaseDetail } from '../portfolio';

const sompoHimawariCase: CaseDetail = {
  id: 'sompo-himawari',
  project: 'SOMPO Himawari Life',
  client: 'SOMPO Himawari Life',
  year: 'Archive',
  category: 'Recruitment Branding / Web',
  role: 'Brand Strategy / Web / Communication',
  issue: '生命保険会社の採用情報が堅く、若い候補者に働き方の魅力が伝わりにくかった。',
  challenge: '保険業界の堅いイメージを超えて、若者が「働く自分の姿」を想像できる採用体験を作ること。',
  insight: '新卒候補者は「会社の説明」より「この会社で自分がどう働くか」を知りたい。ビジュアルとストーリーで「働く自分の姿」を届けることが共感の鍵。',
  strategy: '採用サイトを「働く自分の物語」として再構成。ビジュアル重視のデザインで、職種別の体験とキャリアの導線を設計。',
  experience: '新卒採用サイト、職種紹介、社員のリアルなストーリー、応募導線まで一貫した採用体験を設計。',
  output: 'Recruitment Website / Brand Concept / Visual Design / Content / Communication',
  impact: '採用ブランドの刷新と、若い候補者の共感獲得・応募意欲向上を実現。',
  images: [
    {
      src: '/assets/migrated/7a4d008b5e9a95f01355.webp',
      caption: '新採用サイト デザイン-WF 詳細 page 50 — サイト全体設計：①会社を知る ②働き方キャリアを知る ③仕事と人を知る ④ひまわりCHANNEL、新規・オンラインからの最新情報交流対応',
    },
    {
      src: '/assets/migrated/efabc41d5e28e014a352.webp',
      caption: '新採用サイト サイトマップ 一覧表 page 87 — TOPからミッション・ビジョン、働く環境と成長キャリア、職種コースと社員紹介、ひまわりCHANNEL、採用情報、社員インタビュー、最新NEWS、ENTRY/MY PAGEまでの完全サイト構成',
    },
    {
      src: '/assets/migrated/11c82427012ef7be8df3.webp',
      caption: '新採用サイト デザイン案 A B C 方向 各案 page 82 — A方向案「人のHEARTを掴む」/ B方向案「Think of health」/ C方向案「あなたの熱意が、人々の健康につながる」3つのKEY-visualデザイン提案',
    },
    {
      src: '/assets/migrated/9ca4de26c0c674cf01ba.webp',
      caption: '新採用サイト TOPページ — 東京タワーを背景に「健康応援企業のリーディングカンパニーとして、世の中に新たな価値観を。」「前例なき主役であれ」',
    },
    {
      src: '/assets/migrated/e05b288fb15c55d03e8b.webp',
      caption: '新採用サイト WF-設計の詳細 page 49 — A.明確な採用要件定義 / B.超柔軟な条件変更 / C.超透明な情報提供、4ステップ設計（認知→関心→選択→共感）とENTRY/MY-PAGE導線',
    },
    {
      src: '/assets/migrated/df5999cf5f88214798bb.webp',
      caption: 'マインド志向MAPから共感部分を抽出分析 page 29 — ユーザーボイス分析・オフィシャルボイス分析から共感抽出、リアルな社員と仕事の関わりと活躍ビジョン・成長キャリアロードを見せる',
    },
    {
      src: '/assets/migrated/3f751ba0c6b7f7e2279c.webp',
      caption: '新採用サイト デザイン-WF 拡大詳細 A page 51 — ①会社を知る（ミッション・ビジョン）②働き方キャリアを知る（3年後・5年後の活躍ビジョン）③仕事と人を知る（職種紹介と活躍社員）の詳細設計',
    },
    {
      src: '/assets/migrated/62dfdfae836e3b34ee1c.webp',
      caption: '新採用サイト TOPページ（下部）— 職種紹介・本社×営業対談・営業×営業対談・プロジェクト紹介、HERO「だから、数々の「業界初」が生まれる。」',
    },
    {
      src: '/assets/migrated/aa127e0dee5f68034a5a.webp',
      caption: 'ターゲットアプローチ・デザインアウトプット展開 page 31 — AISASの流れで視覚動線を取り入れてFAN層を拡大、CONCEPT→PROJECT→CAREER STEPS→GROWTH RODOの設計展開',
    },
    {
      src: '/assets/migrated/9fe4cab132a468802f9c.webp',
      caption: 'マインド志向MAPの分析 SWOT page 27 — Rakuten みん就データ「志望動機・学生さんの声」からも抜粋抽出・追加分析、ユーザーボイス分析と直近の就活生の志向データから採用の課題を抽出',
    },
    {
      src: '/assets/migrated/8165a39e5e553a2e5420.webp',
      caption: 'SOMPO ひまわり生命 - 新採用サイト WF- 設計の詳細 — ①会社を知る ②働き方キャリアを知る ③仕事と人を知る ④ひまわりCHANNELの4ステップ設計詳細と各セクションの導線設計',
    },
    {
      src: '/assets/migrated/606baad7c68c4ab8020e.webp',
      caption: '新採用サイト構築 デザインコンテンツの強化 ひまわりCHANNEL page 53 — ひまわりCHANNEL WEB説明動画 WFとWEB説明動画詳細、CHAPTER 01〜03の動画コンテンツ設計',
    },
    {
      src: '/assets/migrated/15fd0d34364ae58e7376.webp',
      caption: 'FAN層を拡大させる コミュニケーション設計 page 9 — 学生ユーザーの動向を多角的視点から分析し、インサイトから抽出した新しい採用サイトを構築する',
    },
    {
      src: '/assets/migrated/8df1d734db04b69aa769.webp',
      caption: '共感MAPの分析から導く 解決策の方法 page 30 — ユーザーボイスとオフィシャル発信のギャップ分析、乖離する問題点と各部門の事業コンセプト明確化など解決策を導く',
    },
    {
      src: '/assets/migrated/415c2e352a73410c6fae.webp',
      caption: 'SOMPOひまわり生命様 新採用サイト 構成表示の効果の踏襲 page 83 — アイキャッチムービング表示とグローバルメニュー構成表示、TOPのグローバルメニューはプルダウン式で各コンテンツを表示',
    },
    {
      src: '/assets/migrated/05725f117f55a54b9d26.webp',
      caption: '改めて-SOMPOひまわり生命様 新採用サイト デザイン-WF 詳細 page 81 — ①会社を知る ②働き方キャリアを知る ③仕事と人を知る ④ひまわりCHANNEL の4ステップ設計と「新規・オンラインからの最新情報交流対応」含む全体WF詳細、ENTRY / MY-PAGE導線、社員インタビュー・RECENT EVENT NEWS・共感パートまでの完全設計',
    },
    {
      src: '/assets/migrated/a672f03bd2996ae5c1dd.webp',
      caption: '新採用サイト サイトマップ 一覧表 page 87 — TOPからミッション・ビジョン／働く環境と成長キャリア／職種コースと社員紹介／ひまわりCHANNEL（WEB説明動画・公式Facebook・YouTube）／WEB説明会・セミナー・インターンシップ情報／採用情報募集要項／社員インタビュー一覧（女性活躍・女性座談会・キャリア活躍・キャリア座談会）／最新NEWS／ENTRY／MY PAGEの完全サイト構成',
    },
    {
      src: '/assets/migrated/4916eab96494ae376ef4.webp',
      caption: 'SOMPOひまわり生命 採用サイト — 「万が一だけでなく、毎日の健康を支える。生命保険の在り方を変革する。」「前例なき主役であれ」RECRUITING SITE',
    },
    {
      src: '/assets/migrated/4f1b1067e4bb6988dd3a.webp',
      caption: '新採用サイト構築 DESIGN設計 page 43 — アウトプット 新採用サイト構築 DESIGN設計、PLAN & DESIGNの成果物としてのデザイン設計アウトプット',
    },
    {
      src: '/assets/migrated/ce1fb835d8874904612a.webp',
      caption: 'SOMPOひまわり生命 採用サイト — 「あなたの熱意が、人々の健康につながる。」「Think of health エネルギーをチャレンジに」RECRUITING SITE',
    },
    {
      src: '/assets/migrated/f5ce71202d634487cb7a.webp',
      caption: 'SOMPOひまわり生命 RECRUITING SITE — TALK SESSION 内定者座談会、若手社員4名のPROFILEページと座談会コンテンツ',
    },
    {
      src: '/assets/migrated/08c17340679fdded9f9a.webp',
      caption: 'A/B/C方向案 ビジュアル比較 page 66 — A方向案「人のHEARTを掴む」/ B方向案「Think of health」/ C方向案「あなたの熱意が、人々の健康につながる」3案のビジュアル並べて比較',
    },
    {
      src: '/assets/migrated/453637cbacb444ba27dd.webp',
      caption: 'SOMPOひまわり生命 採用サイト — 営業店勤務社員 × 営業店勤務社員 特別対談「健康を応援する保険を広めるため、代理店の声を傾聴する。」見留圭 × 伊藤未樹 プロフィール対談ページ',
    },
    {
      src: '/assets/migrated/8f12e0c213a24539b196.webp',
      caption: 'A方向 / 新採用サイト コピー案 ビジュアル案 page 65 — 「人のHEARTを掴む 君のOMOIYARI 健康プロデュース」A方向の詳細コピー案とビジュアル展開、採用MAIN COPY・KEY-visual・4sliderの構成',
    },
    {
      src: '/assets/migrated/cb796ccdae2b88cc2239.webp',
      caption: '新採用サイト構築 ひまわりCHANNEL WEB説明動画 WF page 84 — ひまわりCHANNELで「様々な理解を深めよう」、SOMPOひまわり生命WEB説明会、CHAPTER 01〜03（会社を知る／働き方キャリアを知る／仕事と人を知る）の動画WF設計',
    },
    {
      src: '/assets/migrated/8d3e0699795faf68ef4a.webp',
      caption: 'A方向 / 新採用サイト コピー案 ビジュアル案 page 64 — 「人のHEARTを掴む 君のOMOIYARI 健康プロデュース」A方向のコピー案とビジュアル案、働き方キャリアを知る／仕事と人を知る／ひまわりCHANNELのデザイン展開',
    },
    {
      src: '/assets/migrated/f3f84b7c147b913886fc.webp',
      caption: 'マインド志向MAP ユーザーボイス分析から 各それぞれの比較検証 page 28 — ユーザーボイス分析・直近の就活生の志向データから、御社に共感できている側面と具体的な業務内容を取りこぼしている側面の比較検証',
    },
  ],
};

export default sompoHimawariCase;